export default __webpack_public_path__ + "static/media/lemonShot.e3b5137f.jpg";